export default "__VITE_ASSET__Bz9FHsFK__"